import { create } from 'zustand';

/** Sinaliza que a API recusou uma rota de admin por falta de MFA (403 MFA_REQUIRED). */
export const useAdminMfaStore = create<{ isMfaRequired: boolean; setMfaRequired: (value: boolean) => void }>((set) => ({
  isMfaRequired: false,
  setMfaRequired: (value) => set({ isMfaRequired: value }),
}));
